<app-kpd-selector
        [kpdCode]="kpdCode"
        [kpdName]="kpdName"
        [placeholder]="placeholder"
        [isInvalid]="control.invalid && (control.dirty || control.touched)"
        (kpdSelected)="onKpdSelected($event)"
        (kpdCleared)="onKpdCleared()">
</app-kpd-selector>
